var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.5C10.7578 18.5 6.75 14.4922 6.75 9.5C6.75 4.57812 10.7578 0.5 15.75 0.5C20.6719 0.5 24.75 4.57812 24.75 9.5C24.75 14.4922 20.6719 18.5 15.75 18.5ZM19.2656 21.875C26.0156 21.875 31.5 27.3594 31.5 34.1094C31.5 35.4453 30.375 36.5 29.0391 36.5H2.39062C1.05469 36.5 0 35.4453 0 34.1094C0 27.3594 5.41406 21.875 12.1641 21.875H19.2656Z",
    fill: "#476930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLogin);
export default __webpack_public_path__ + "static/media/btnLogin.44568cc951b551739a012b71eee838ce.svg";
export { ForwardRef as ReactComponent };